import { useMemo } from 'react';
import {
  Container,
  Wrapper,
  Title,
  IconsWrapper,
  ArrowSortRegularIcon,
  FilterRegularIcon,
  IconWrapper,
  FilterBadgeIndicator,
  SortBadgeIndicator,
} from './TabHeader.styled';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';
import { FilterTags } from 'src/components/Tickets/components/mobile/FilterTags/FilterTags';

export const TabHeader = () => {
  const {
    mobileFilterToggle,
    mobileSortToggle,
    filterOptions,
    sortedColumnId,
    sortedOrder,
  } = useServiceDeskContext();

  const { isFilteringApplied, isSortingApplied } = useMemo(() => {
    const filter = Object.values(filterOptions)?.some((options) =>
      options.some((op) => op.checked)
    );
    const sort = !!sortedColumnId && !!sortedOrder;
    return { isFilteringApplied: filter, isSortingApplied: sort };
  }, [filterOptions, sortedColumnId, sortedOrder]);

  return (
    <Container>
      <Wrapper>
        <Title>Tickets list</Title>
        <IconsWrapper>
          <IconWrapper>
            <ArrowSortRegularIcon onClick={() => mobileSortToggle(true)} />
            {isSortingApplied && <SortBadgeIndicator />}
          </IconWrapper>
          <IconWrapper>
            <FilterRegularIcon onClick={() => mobileFilterToggle(true)} />
            {isFilteringApplied && <FilterBadgeIndicator />}
          </IconWrapper>
        </IconsWrapper>
      </Wrapper>
      <FilterTags />
    </Container>
  );
};
